import script from "./InformacoesAcaoView.vue?vue&type=script&setup=true&lang=js"
export * from "./InformacoesAcaoView.vue?vue&type=script&setup=true&lang=js"

import "./InformacoesAcaoView.vue?vue&type=style&index=0&id=3b55b48f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b55b48f"]])

export default __exports__